export default "__VITE_ASSET__NU_OtR3$__"